angular.module('app').factory('popupsService', [
    'Restangular',
    'settings',
    function (Restangular, settings) {
        var restAngular = Restangular.withConfig(function (Configurer)
        {
            Configurer.setBaseUrl(settings.apiURL);
        });

        restAngular = restAngular.all("/popup/");

        return {
            create: function (requestData) {
                return restAngular.
                    one("create").
                    post("", requestData)
            },
            update: function (requestData) {
                return restAngular.
                    one("change").
                    post("", requestData)
            },
            getPopups: function (requestData) {
                return restAngular.
                    one("get").
                    customGET(param(requestData))
            },
            deletePopupById: function (requestData) {
                return restAngular.
                    one("delete").
                    customGET(param(requestData))
            },
            getPopupById: function (popupId) {
                return restAngular.
                    one("get").
                    customGET(param(popupId))
            },
            getActualNames: function (requestData) {
                return restAngular.
                    one("getActualNames").
                    customGET(param(requestData))
            },
            getRepeatTypes: function () {
                return restAngular.
                    one("getRepeatTypes").
                    get()
            },
            toggleItemInactive: function (pageId, title) {
                var requestObject = {
                    id: pageId,
                    status: title !== 'Publish' ? "inactive" : "published"
                };
                return restAngular.
                one("status").
                post("", {popup: requestObject})
            },
            changeOrder: function (requestData) {
                return restAngular.
                one("changeOrder").
                post("", requestData)
            }
        }
    }
]);